import { render, staticRenderFns } from "./DetailMasterRate.vue?vue&type=template&id=774defb7"
import script from "./DetailMasterRate.vue?vue&type=script&lang=js"
export * from "./DetailMasterRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports